import React, { useEffect, useState } from "react";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import * as api from "./../../api/api";
import Banner from "./../banner/banner";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function AboutUs() {
  const classes = useStyles();
  const [aboutUs, setAboutUs] = useState("");
  const [loader, setLoader] = useState(true);
  const [banner, setBanner] = useState("");
  useEffect(() => {
    document.title = "121five.com - About Us";
    window.scrollTo(0, 0);
    aboutUsApi();
  }, []);

  const aboutUsApi = async () => {
    try {
      let response = await api.aboutUs();
      let res = await api.banner(1);
      if (response) {
        setAboutUs(response);
        if (res) {
          setBanner(res.image);
          setLoader(false);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>

            <div className="col-lg-9 col-md-12">
              <div className="about-us-area">
                {Object.keys(aboutUs).map((item, key) => {
                  let desc = aboutUs[item].description;
                  return (
                    <div className="single-about" key={key}>
                      <h4>{aboutUs[item].title}</h4>
                      <p dangerouslySetInnerHTML={{ __html: desc }}></p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
